<template>
  <Draggable
    ghostClass="dragging-row"
    tag="tbody"
    :list="data.subjects"
    @change="onChange"
    :options="{ animation: 200 }"
    handle=".drag-handle"
    :disabled="isUpdating"
  >
    <slot></slot>
  </Draggable>
</template>
<script>
import Draggable from "vuedraggable";
import apiClient from "@/services/axios";

export default {
  components: {
    Draggable,
  },
  inject: ["data"],
  data() {
    return {
      isUpdating: false,
    };
  },
  methods: {
    handleApiError(error, defaultMessage) {
      // Check for PACK_PERMISSION_ERROR
      if (
        error.response?.data?.errorCode === "PACK_PERMISSION_ERROR" ||
        error.response?.data?.error?.errorCode === "PACK_PERMISSION_ERROR"
      ) {
        this.$message.error(this.$t("errorCode.PACK_PERMISSION_ERROR"));
        return;
      }
      // Fallback to default error message
      this.$message.error(
        error.response?.data?.message || defaultMessage || this.$t("error.erreur")
      );
    },
    async onChange(evt) {
      // If no actual change happened, return early
      if (!evt.moved || this.isUpdating) return;

      this.isUpdating = true;

      // Get configId from the first subject if available
      const configId = this.data.subjects.length > 0 && this.data.subjects[0].configId
        ? this.data.subjects[0].configId
        : null;

      if (!configId) {
        this.isUpdating = false;
        return;
      }

      const subjects = this.data.subjects.map((item, index) => ({
        subjectId: item.subject ? (item.subject._id || item.subject) : item._id,
        order: index,
      }));

      const updates = [{
        configId: configId,
        subjects: subjects,
      }];

      try {
        await apiClient.put("/bulletin/college/config/update-orders", {
          data: updates,
        });
        // Update the orders in local data
        this.data.subjects = this.data.subjects.map((item, index) => ({
          ...item,
          order: index,
        }));
        this.$message.success(this.$t("college.bulletin.config.subjectOrderUpdated"));
      } catch (error) {
        this.handleApiError(error, this.$t("college.bulletin.config.failedToUpdateSubjectOrder"));
      } finally {
        this.isUpdating = false;
      }
    },
  },
};
</script>
<style scoped>
.dragging-row {
  opacity: 0.5;
}
</style>

